<template>
  <base-spinner v-if="loading" />
  <div v-else>
    <div class="p-4">
      <b-alert :show="error && error.length ? true : false" variant="danger">
        <div v-if="Array.isArray(error)">
          <div class="d-flex flex-column my-1" v-for="(error_text, index) in error" :key="index">
            {{ error_text }}
          </div>
        </div>
        <div v-else>
          <div v-html="error || '&nbsp;'"></div>
        </div>
      </b-alert>
      <div class="row align-items-center justify-content-between">
        <div class="col-lg-4 col-md-6 col-xs-12">
          <div
            v-if="isReservationTrip ? data?.reservation?.client?._id : data?.contract?.client?._id"
            class="header-block d-flex align-items-center"
          >
            <div class="icon-container">
              <img src="@/assets/images/icons/user-profile.svg" alt="user-profile" />
            </div>
            <div class="mx-2">{{ $t('client') }}</div>
            <div class="bold-text">
              {{ clientName }}
            </div>
          </div>
        </div>

        <div
          :class="[
            isLangRtl ? 'justify-content-start' : 'justify-content-end',
            'col-lg-4',
            'col-md-12',
            'col-xs-12',
          ]"
          v-if="data?.status"
        >
          <ChangeTripStatus
            :isMainDriverAssigned="data?.mainDriver?._id"
            :status="data.status"
            :_id="data._id"
            @getData="getData"
            :serviceAllowance="tripServiceAllowanceAmount"
          />
        </div>

        <!-- <div class="col-lg-4 col-md-6 col-xs-12">
          <div 
          v-if="data?.reservation?.category?._id" 
          class="header-block d-flex align-items-center"
          >
            <div class="icon-container">
              <img 
              src="@/assets/images/icons/column-vertical.svg" 
              alt="column-vertical" 
              />
            </div>
            <div style="margin-inline: 0.5rem">
              {{ $t("reservation-category") }}
            </div>
            <div class="bold-text">
              {{
              isLangRtl
              ? data?.reservation?.category?.arabicName
              : data?.reservation?.category?.name
              }}
            </div>
          </div>
        </div> -->
      </div>
      <div class="row align-items-center mt-2">
        <div class="col-lg-4 col-md-6 col-xs-12">
          <div v-if="zone" class="header-block d-flex align-items-center">
            <div class="icon-container">
              <img src="@/assets/images/icons/column-vertical.svg" alt="column-vertical" />
            </div>
            <div class="mx-2">
              {{ $t('zone') }}
            </div>
            <div class="bold-text">
              {{ isLangRtl ? zone.arabicName : zone.name }}
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-xs-12">
          <div v-if="garage" class="header-block d-flex align-items-center">
            <div class="icon-container">
              <img src="@/assets/images/icons/column-vertical.svg" alt="garage" />
            </div>
            <div class="mx-2">
              {{ $t('garage') }}
            </div>
            <div class="bold-text">
              {{ isLangRtl ? garage.arabicName : garage.name }}
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-xs-12" v-if="rating">
          <div class="d-flex align-items-center justify-content-end gap-2">
            <span class="text-muted fw-semibold">
              {{ $t('Trip_Rating') }}
            </span>

            <i class="bi bi-star-fill text-warning"></i>

            <span class="fw-semibold">{{ rating }}/5</span>
            <button class="btn-rating" @click="$refs.feedbackModal.open()">
              <i class="bi bi-chat-square-text"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="row align-items-center mt-2">
        <div class="col-lg-4 col-md-6 col-xs-12">
          <div
            v-if="beneficiary && beneficiary.externalReferenceId"
            class="header-block d-flex align-items-center"
          >
            <div class="icon-container">
              <img src="@/assets/images/icons/column-vertical.svg" alt="column-vertical" />
            </div>
            <div class="mx-2 fo">
              {{ $t('external-reference-id') }}
            </div>
            <div class="bold-text">
              {{ beneficiary.externalReferenceId }}
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-xs-12">
          <div v-if="beneficiary" class="header-block d-flex align-items-center">
            <div class="icon-container">
              <img src="@/assets/images/icons/column-vertical.svg" alt="column-vertical" />
            </div>
            <div class="mx-2">
              {{ $t('name') }}
            </div>
            <div class="bold-text">
              {{ isLangRtl ? beneficiary.arabicName || '---' : beneficiary.englishName || '---' }}
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-xs-12">
          <div
            v-if="beneficiary && beneficiary.phoneNumber"
            class="header-block d-flex align-items-center"
          >
            <div class="icon-container">
              <img src="@/assets/images/icons/phone-call.svg" alt="column-vertical" />
            </div>
            <div class="mx-2">
              {{ $t('phone-number') }}
            </div>
            <div class="bold-text">
              {{ beneficiary.phoneNumber || '---' }}
            </div>
          </div>
        </div>
        <!-- <div class="col-lg-4 col-md-6 col-xs-12">
          <div 
          v-if="data?.service?.category?._id" 
          class="header-block d-flex align-items-center"
          >
            <div class="icon-container">
              <img 
              src="@/assets/images/icons/column-vertical.svg" 
              alt="column-vertical" 
              />
            </div>
            <div style="margin-inline: 0.5rem">
              {{ $t("service-category") }}
            </div>
            <div class="bold-text">
              {{
              isLangRtl
              ? data?.service?.category?.arabicName
              : data?.service?.category?.name
              }}
            </div>
          </div>
        </div> -->
        <!-- <div 
        :class="[
            isLangRtl ? 'justify-content-start' : 'justify-content-end',
            'col-lg-4',
            'col-md-12',
            'col-xs-12',
          ]" 
          v-if="data?.status"
        >
        <ChangeTripStatus :isMainDriverAssigned="data?.mainDriver?._id" :status="data.status" :_id="data._id" @getData="getData" :serviceAllowance="tripServiceAllowanceAmount" />
        </div> -->
      </div>

      <!-- <div v-if="data?.completedAt && (data?.status === 'Trip-Completed' || data?.status === 'Trip-Completed-Note')"
        class="row align-items-center gap-2 m-1 mt-2">
        <div class="col-lg-4 col-md-6 col-xs-12 header-block d-flex">
          <div class="d-flex align-items-center mb-2 gap-1">

            <div class="icon-container">
              <img :src="require(`@/assets/images/icons/clock-2-icon.svg`)" alt="clock-icon" />
            </div>

            <div class="mx-2">
              {{ $t("completed") }}
            </div>

            <div class="bold-text">
              {{ completedAtFormatted }}
            </div>

          </div>
        </div>
      </div> -->

      <!-- <div class="row align-items-center mb-2 mt-2" v-if="tripService?.description">
      <div class="col-lg-8 col-md-6 col-xs-12">
        <div class="header-block d-flex align-items-center">
          <div class="icon-container">
            <img
              src="@/assets/images/icons/column-vertical.svg"
              alt="column-vertical"
            />
          </div>
          <div style="margin-inline: 0.5rem">{{ $t("description") }}</div>
          <div class="bold-text d-flex justify-content-end">
            {{ tripService?.description }}
          </div>
        </div>
      </div>
      </div> -->
      <hr />
      <div
        v-if="data?.subStatus === 'Reviewed'"
        class="info-block d-flex align-items-center justify-content-between mb-3"
        style="background: var(--color-121)"
      >
        <div class="d-flex align-items-center">
          <div class="icon me-2" style="background: var(--color-92)">
            <img
              :src="require(`@/assets/images/icons/arrow-refresh-icon.svg`)"
              alt="arrow-refresh-icon"
            />
          </div>
          <div>
            {{ $t('reviewed-message', { id: data?._id }) }}
          </div>
        </div>
        <div v-if="!$store.getters['enums/is_not_permitted']('markAsUnRead')">
          <base-button variant="info" :loading="action_loading" @click="unview">
            {{ $t('mark-as-unread') }}
          </base-button>
        </div>
      </div>
      <div
        v-else-if="data?.subStatus === 'Approval-Needed'"
        class="info-block d-flex align-items-center justify-content-between mb-3"
        style="background: var(--color-121)"
      >
        <div class="d-flex align-items-center">
          <div class="icon me-2" style="background: var(--color-92)">
            <img
              :src="require(`@/assets/images/icons/arrow-refresh-icon.svg`)"
              alt="arrow-refresh-icon"
            />
          </div>
          <div>
            {{ $t('approval-needed-message', { id: data?._id }) }}
          </div>
        </div>
        <div v-if="!$store.getters['enums/is_not_permitted']('markAsRead')">
          <base-button variant="info" :loading="action_loading" @click="viewed">
            {{ $t('mark-as-read') }}
          </base-button>
        </div>
      </div>
      <div
        v-else-if="data?.subStatus === 'Action-Required'"
        class="info-block d-flex align-items-center justify-content-between mb-3"
        style="background: var(--color-123)"
      >
        <div class="d-flex align-items-center">
          <div class="icon me-2" style="background: var(--color-124)">
            <img
              :src="require(`@/assets/images/icons/alert-triangle-icon.svg`)"
              alt="alert-triangle-icon"
            />
          </div>
          <div v-if="checkTime">
            {{ $t('action-required-message-more-than-24', { id: data?._id }) }}
          </div>
          <div v-else>
            {{ $t('action-required-message-less-than-24', { id: data?._id }) }}
          </div>
        </div>
        <div v-if="!$store.getters['enums/is_not_permitted']('markAsRead')">
          <base-button variant="info" :loading="action_loading" @click="viewed">
            {{ $t('mark-as-read') }}
          </base-button>
        </div>
      </div>
      <div
        v-else-if="data?.status === 'Trip-Started'"
        class="info-block d-flex align-items-center justify-content-between mb-3"
        style="background: var(--color-121)"
      >
        {{ $t('trip-started-toast') }}
      </div>
      <div
        v-else-if="data?.status === 'Trip-Arrived-At-Pickup-Location'"
        class="info-block d-flex align-items-center justify-content-between mb-3"
        style="background: var(--color-121)"
      >
        {{ $t('trip-arrived-at-pickup-location-toast') }}
      </div>
      <!-- <div
        v-else-if="data?.status === 'Trip-Passenger-Picked-Up'"
        class="info-block d-flex align-items-center justify-content-between mb-3"
        style="background: var(--color-121)">
        {{ $t("trip-passenger-picked-up-toast") }}
      </div> -->
      <div
        v-else-if="data?.status === 'Trip-Arrived-To-Dropped-Off'"
        class="info-block d-flex align-items-center justify-content-between mb-3"
        style="background: var(--color-121)"
      >
        {{ $t('trip-arrived-to-dropped-off-toast') }}
      </div>

      <!-- <div
        v-else-if="data?.status === 'Trip-Passenger-Dropped-Off'"
        class="info-block d-flex align-items-center justify-content-between mb-3"
        style="background: var(--color-121)">
        {{ $t("trip-passenger-dropped-off-toast") }}
      </div> -->
      <div
        v-else-if="data?.status === 'Trip-Completed' || data?.status === 'Trip-Completed-Note'"
        class="info-block d-flex align-items-center justify-content-between mb-3"
        style="background: var(--color-121)"
      >
        {{ $t('trip-completed-toast') }}
      </div>
      <div
        v-if="false"
        class="info-block d-flex align-items-center justify-content-between mb-3"
        style="background: var(--color-126)"
      >
        <div class="d-flex align-items-center">
          <div class="icon me-2" style="background: var(--color-127)">
            <img :src="require(`@/assets/images/icons/clock-2-icon.svg`)" alt="clock-icon" />
          </div>
          <div>Trip #id has been newly created. Please review and approve the Auto-assign.</div>
        </div>
        <div>
          <base-button variant="secondary2">{{ $t('approve') }}</base-button>
        </div>
      </div>
      <div class="row align-items-center mb-3">
        <div class="col-lg-3 col-md-6 col-xs-12" v-if="blanketOrder">
          <span style="color: var(--color-66)">{{ $t('blanket-orders-id') }} : </span>
          <span class="bold-text">{{ blanketOrder._id }}</span>
        </div>
        <div class="col-lg-3 col-md-6 col-xs-12" v-if="blanketOrder">
          <span style="color: var(--color-66)">{{ $t('contract-code') }} : </span>
          <span class="bold-text">{{ blanketOrder.orderCode || '---' }}</span>
        </div>
        <div class="col-lg-2 col-md-6 col-xs-12" v-if="data?.contract">
          <span style="color: var(--color-66)">{{ $t('contract-id') }} : </span>
          <span class="bold-text">{{ data?.contract?._id }}</span>
        </div>
        <div class="col-lg-2 col-md-6 col-xs-12" v-if="data?.route?._id">
          <span style="color: var(--color-66)"> {{ $t('route') }} : </span>
          <span class="bold-text">
            {{ isLangRtl ? data?.route?.arabicName : data?.route?.name }}
          </span>
        </div>
        <div class="col-lg-2 col-md-6 col-xs-12" v-if="data?._id">
          <span style="color: var(--color-66)">{{ $t('trip-id') }} : </span>
          <span class="bold-text text-capitalize">{{ data?._id }}</span>
        </div>
        <div
          class="col-lg-2 col-md-6 col-xs-12 ms-auto"
          v-if="data?.reservation?._id && hasPermissionPrintSalesOrder"
        >
          <base-button
            variant="secondary"
            id="download-details-btn"
            :loading="pdfLoading"
            @click="generatePDF"
          >
            {{ $t('print') }}
            <img
              :src="require(`@/assets/images/printer.png`)"
              alt="image-placeholder"
              class="cursor-pointer ms-2"
            />
          </base-button>
        </div>
        <div
          class="col-lg-3 col-md-6 col-xs-12 ms-auto"
          style="position: relative"
          v-if="
            data?._id &&
            (data.status === 'Trip-Completed' ||
              data.status === 'Trip-Completed-Note' ||
              data.status === 'Trip-Arrived-To-Dropped-Off' ||
              data.status === 'Trip-Passenger-Dropped-Off' ||
              data.status === 'Trip-Passenger-Picked-Up' ||
              data.status === 'Trip-Arrived-At-Pickup-Location' ||
              data.status === 'Trip-Started')
          "
        >
          <base-button variant="primary" @click="toggleShowMap">
            <span class="showMap">
              {{ $t('show-map') }}
            </span>
          </base-button>
          <div class="show-map-options" v-if="showMapSelection" v-click-outside="toggleShowMap">
            <div class="option" @click="showActualRouteModal('third-party')">
              {{ $t('show-bus-route') }}
            </div>
            <div class="option" @click="showMobileRouteMapModal">
              {{ $t('show-mobile-route') }}
            </div>
            <div class="option" @click="showActualRouteModal('both')">
              {{ $t('show-combined-route') }}
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 col-xs-12 ms-auto" v-if="showCompleteWithNote">
          <base-button variant="secondary" @click="$bvModal.show('complete-with-note-modal')">
            {{ $t('complete-with-note') }}
          </base-button>
        </div>
      </div>

      <div class="trip-place-container mb-3">
        <div class="d-flex align-items-center justify-content-between mb-3">
          <div class="d-flex align-items-center">
            <div class="icon-container">
              <img src="@/assets/images/icons/Group.svg" alt="Group" />
            </div>
            <div style="margin-inline-start: 0.5rem">
              {{ $t('cities-and-address') }}
            </div>
          </div>
          <div v-if="allowEdit || showCancelButton" class="d-flex align-items-center gap-2">
            <div v-if="allowEdit">
              <base-button variant="info" @click="moveToEdit(data?._id)">
                {{ $t('edit-journey') }}
              </base-button>
            </div>
            <div v-if="showCancelButton">
              <base-button variant="danger" @click="showCancelTripModel">
                {{ $t('cancel-trip') }}
              </base-button>
            </div>
          </div>
        </div>
        <!-- <div class="d-flex justify-content-between mb-4">
          <div v-if="data?.service?.startCity?._id">
            <div>{{ $t("from-city") }}</div>
            <div class="bold-text">
              {{
              isLangRtl
              ? data?.service?.startCity?.arabicName
              : data?.service?.startCity?.name
              }}
            </div>
          </div>
          <div v-if="data?.service?.endCity?._id">
            <div>{{ $t("to-city") }}</div>
            <div class="bold-text">
              {{
              isLangRtl
              ? data?.service?.endCity?.arabicName
              : data?.service?.endCity?.name
              }}
            </div>
          </div>
        </div> -->
        <div style="position: relative">
          <div class="route"></div>
          <div
            class="point start"
            v-if="data?.driver?.garage?.garageLocation?.name"
            v-b-tooltip.hover="{
              title:
                data?.driver?.garage?.garageLocation?.name +
                '\n' +
                data?.driver?.garage?.garageLocation?.location,
              placement: isLangRtl ? 'righttop' : 'lefttop',
            }"
          ></div>
          <div
            class="point"
            :style="isLangRtl ? 'right: 38%;' : 'left: 38%;'"
            :class="{
              'pick-up': data?.driver?.garage?.garageLocation?.name,
              start: !data?.driver?.garage?.garageLocation?.name,
            }"
            v-if="data?.startLocation?.name"
            v-b-tooltip.hover="{
              title: data?.startLocation?.name,
              placement:
                isLangRtl && !data?.driver?.garage?.garageLocation?.name ? 'righttop' : 'lefttop',
            }"
          ></div>
          <div
            class="point"
            :style="isLangRtl ? 'left: 38%;' : 'right: 38%;'"
            :class="{
              'drop-off': data?.driver?.garage?.garageLocation?.name,
              end: !data?.driver?.garage?.garageLocation?.name,
            }"
            v-if="data?.endLocation?.name"
            v-b-tooltip.hover="{
              title: data?.endLocation?.name,
              placement:
                isLangRtl && !data?.driver?.garage?.garageLocation?.name ? 'lefttop' : 'righttop',
            }"
          ></div>
          <div
            class="point end"
            v-if="data?.driver?.garage?.garageLocation?.name"
            v-b-tooltip.hover.lefttop="
              data?.driver?.garage?.garageLocation?.name +
              '\n' +
              data?.driver?.garage?.garageLocation?.location
            "
          ></div>
        </div>
        <div class="d-flex justify-content-between mt-3">
          <div
            :class="['place', `${isLangRtl ? 'end' : 'start'}`]"
            v-if="data?.driver?.garage?.garageLocation?.name"
          >
            {{ $t('garage') }}
          </div>
          <div
            :class="[
              'place',
              `${isLangRtl ? 'end' : 'start'}`,
              { 'drop-off': data?.driver?.garage?.garageLocation?.name },
            ]"
            v-if="data?.startLocation?.name"
          >
            {{ $t('pick-up-location') }}
          </div>
          <div
            :class="[
              'place',
              `${isLangRtl ? 'start' : 'end'}`,
              { 'drop-off': data?.driver?.garage?.garageLocation?.name },
            ]"
            v-if="data?.endLocation?.name"
          >
            {{ $t('drop-off-location') }}
          </div>
          <div
            :class="['place', `${isLangRtl ? 'start' : 'end'}`]"
            v-if="data?.driver?.garage?.garageLocation?.name"
          >
            {{ $t('garage') }}
          </div>
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-betweem">
        <div style="flex: 0.8">
          <div
            class="mb-3"
            v-if="
              data?.actualStartTime ||
              data?.deviationInStartTime ||
              data?.completedAt ||
              data?.deviationInEndTime
            "
          >
            <div class="d-flex align-items-center mb-2">
              <div class="icon-container">
                <img src="@/assets/images/icons/clock.svg" alt="clock" />
              </div>
              <div style="margin-inline-start: 0.5rem">
                {{ $t('trip-timing-details') }}
              </div>
            </div>
            <div class="row">
              <div class="col-lg-3 col-md-6 col-xs-12" v-if="data?.actualStartTime">
                <div>{{ $t('actual-start-time') }}</div>
                <div class="bold-text">{{ getActualStartTime }}</div>
              </div>
              <div class="col-lg-3 col-md-6 col-xs-12" v-if="data?.deviationInStartTime">
                <div>{{ $t('deviation-in-start-time') }}</div>
                <div class="bold-text">{{ getDeviationInStartTime }}</div>
              </div>
              <div class="col-lg-3 col-md-6 col-xs-12" v-if="data?.completedAt">
                <div>{{ $t('actual-end-time') }}</div>
                <div class="bold-text">{{ getActualEndTime }}</div>
              </div>
              <div class="col-lg-3 col-md-6 col-xs-12" v-if="data?.deviationInEndTime">
                <div>{{ $t('deviation-in-end-time') }}</div>
                <div class="bold-text">{{ getDeviationInEndTime }}</div>
              </div>
            </div>
          </div>
          <div>
            <div class="d-flex align-items-center mb-2">
              <div class="icon-container">
                <img src="@/assets/images/icons/calendar-03.svg" alt="calendar-03" />
              </div>
              <div style="margin-inline-start: 0.5rem">
                {{ $t('dates-and-time') }}
              </div>
            </div>
            <div class="row">
              <div class="col-lg-3 col-md-6 col-xs-12">
                <div>{{ $t('start-date') }}</div>
                <div class="bold-text">{{ getStartDate }}</div>
              </div>
              <div class="col-lg-3 col-md-6 col-xs-12">
                <div>{{ $t('start-time') }}</div>
                <div class="bold-text">{{ getStartTime }}</div>
              </div>
              <div class="col-lg-3 col-md-6 col-xs-12">
                <div>{{ $t('end-date') }}</div>
                <div class="bold-text">{{ getEndDate }}</div>
              </div>
              <div class="col-lg-3 col-md-6 col-xs-12">
                <div>{{ $t('end-time') }}</div>
                <div class="bold-text">{{ getEndTime }}</div>
              </div>
            </div>
          </div>
        </div>
        <div style="flex: 0.2">
          <div class="mb-3 assign-block" v-if="data?.actualTripTime">
            <div>{{ $t('actual-trip-time') }}</div>
            <div class="bold-text">15:00 minutes</div>
          </div>
          <div class="assign-block" v-if="data?.totalDeviation">
            <div>{{ $t('total-deviation') }}</div>
            <div class="bold-text">00:50 minutes</div>
          </div>
        </div>
      </div>
      <hr />
      <div
        v-if="
          data?.initialOdoMeter ||
          data?.finalOdoMeter ||
          data?.distance ||
          data?.deviationInDistance
        "
      >
        <div class="d-flex align-items-center mb-3">
          <div style="flex: 0.8">
            <div class="d-flex align-items-center mb-2">
              <div class="icon-container">
                <img src="@/assets/images/icons/clock.svg" alt="clock" />
              </div>
              <div style="margin-inline-start: 0.5rem">
                {{ $t('trip-distance-details') }}
              </div>
            </div>
            <div class="row">
              <div class="col-lg-3 col-md-6 col-xs-12" v-if="data?.initialOdoMeter">
                <div>{{ $t('initial-odometer-value') }}</div>
                <div class="bold-text">{{ data?.initialOdoMeter.toFixed(2) }} KM</div>
              </div>
              <div class="col-lg-3 col-md-6 col-xs-12" v-if="data?.finalOdoMeter">
                <div>{{ $t('final-odometer-value') }}</div>
                <div class="bold-text">{{ data?.finalOdoMeter.toFixed(2) }} KM</div>
              </div>
              <div class="col-lg-3 col-md-6 col-xs-12" v-if="data?.distance">
                <div>{{ $t('actual-distance') }}</div>
                <div class="bold-text">{{ data?.distance.toFixed(2) }} KM</div>
              </div>
              <div class="col-lg-3 col-md-6 col-xs-12" v-if="data?.deviationInDistance">
                <div>{{ $t('deviation-in-distance') }}</div>
                <div class="bold-text">{{ data?.deviationInDistance.toFixed(2) }} KM</div>
              </div>
            </div>
          </div>
        </div>
        <hr />
      </div>
      <div class="row">
        <div
          class="col-lg-6 col-md-6 col-xs-12 mb-2"
          v-if="data?.service?.numberOfDrivers || !data?.reservation"
        >
          <div
            class="assign-block d-flex justify-content-between align-items-center"
            :class="{
              'cursor-pointer': data?.mainDriver?._id,
            }"
            @click="moveTo('driver', data?.mainDriver?._id)"
          >
            <div>
              <div class="d-flex align-items-center">
                <div class="avtar" v-if="data?.mainDriver?.vehiclePicture">
                  <img :src="data.mainDriver.vehiclePicture" alt="vehiclePicture" />
                </div>
                <div v-if="data?.mainDriver?._id">
                  <div class="bold-text title">
                    {{ $t('main-driver') }} :
                    {{ isLangRtl ? data?.mainDriver?.arabicName : data?.mainDriver?.name }}
                  </div>
                  <div class="sub-title">
                    {{ $t('iqama-number-entry-driver') }} :
                    <span class="bold-text"> #{{ data?.mainDriver?.idNumber }} </span>
                  </div>
                </div>
                <div v-else>
                  <div class="bold-text title">{{ $t('main-driver') }}</div>
                  <div class="sub-title">{{ $t('driver-not-assigned') }}</div>
                </div>
              </div>
            </div>
            <div class="d-flex align-self-baseline gap-1">
              <b-button
                v-if="
                  !$store.getters['enums/is_not_permitted']('assignDriversToJourney') &&
                  data?.status !== 'Booking-Cancelled' &&
                  data?.status !== 'Booking-Cancelled-Note' &&
                  data?.status !== 'Trip-Arrived-To-Dropped-Off' &&
                  data?.status !== 'Trip-Passenger-Dropped-Off' &&
                  data?.status !== 'Trip-Completed' &&
                  data?.status !== 'Trip-Completed-Note' &&
                  (data?.status === 'Trip-Started'
                    ? !$store.getters['enums/is_not_permitted']('assignDriverForStartedTrip') &&
                      !$store.getters['enums/is_not_permitted']('assignVehicleForStartedTrip')
                    : true)
                "
                class="reassign-btn"
                @click.stop="changeDriver(true)"
              >
                {{ data?.mainDriver?._id ? $t('reassign') : $t('assign') }}
              </b-button>
              <b-button
                v-if="showReassignButton"
                class="reassign-btn"
                @click.stop="changeDriver(true)"
              >
                {{ $t('reassign') }}
              </b-button>
              <b-button
                v-if="
                  !$store.getters['enums/is_not_permitted']('assignDriversToJourney') &&
                  !data?.status?.startsWith('Trip-') &&
                  data?.mainDriver?._id
                "
                class="remove-btn"
                variant="danger"
                @click.stop="showRemoveDriverModal(true)"
              >
                {{ $t('remove-driver') }}
              </b-button>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-xs-12 mb-2" v-if="data?.service?.numberOfDrivers > 1">
          <div
            class="assign-block d-flex justify-content-between align-items-center"
            :class="{
              'cursor-pointer': data?.secondaryDriver?._id,
            }"
            @click="moveTo('driver', data?.secondaryDriver?._id)"
          >
            <div>
              <div class="d-flex align-items-center">
                <div class="avtar" v-if="data?.secondaryDriver?.vehiclePicture">
                  <img :src="data.secondaryDriver.vehiclePicture" alt="vehiclePicture" />
                </div>
                <div v-if="data?.secondaryDriver?._id">
                  <div class="bold-text title">
                    {{ $t('secondary-driver') }} :
                    {{
                      isLangRtl ? data?.secondaryDriver?.arabicName : data?.secondaryDriver?.name
                    }}
                  </div>
                  <div class="sub-title">
                    {{ $t('iqama-number-entry-driver') }} :
                    <span class="bold-text"> #{{ data?.secondaryDriver?.idNumber }} </span>
                  </div>
                </div>
                <div v-else>
                  <div class="bold-text title">
                    {{ $t('secondary-driver') }}
                  </div>
                  <div class="sub-title">
                    {{ $t('driver-not-assigned') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex align-self-baseline gap-1">
              <b-button
                v-if="
                  !$store.getters['enums/is_not_permitted']('assignDriversToJourney') &&
                  data?.status !== 'Booking-Cancelled' &&
                  data?.status !== 'Booking-Cancelled-Note' &&
                  data?.status !== 'Trip-Arrived-To-Dropped-Off' &&
                  data?.status !== 'Trip-Passenger-Dropped-Off' &&
                  data?.status !== 'Trip-Completed' &&
                  data?.status !== 'Trip-Completed-Note' &&
                  (data?.status === 'Trip-Started'
                    ? !$store.getters['enums/is_not_permitted']('assignDriverForStartedTrip') &&
                      !$store.getters['enums/is_not_permitted']('assignVehicleForStartedTrip')
                    : true)
                "
                class="reassign-btn"
                @click.stop="changeDriver(false)"
              >
                {{ data?.secondaryDriver?._id ? $t('reassign') : $t('assign') }}
              </b-button>
              <b-button
                v-if="showReassignButton && data?.secondaryDriver?._id"
                class="reassign-btn"
                @click.stop="changeDriver(false)"
              >
                {{ $t('reassign') }}
              </b-button>
              <b-button
                v-if="
                  !$store.getters['enums/is_not_permitted']('assignDriversToJourney') &&
                  !data?.status?.startsWith('Trip-') &&
                  data?.secondaryDriver?._id
                "
                class="remove-btn"
                variant="danger"
                @click.stop="showRemoveDriverModal(false)"
              >
                {{ $t('remove-driver') }}
              </b-button>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-xs-12 mb-2">
          <div
            class="assign-block d-flex justify-content-between align-items-center"
            :class="{
              'cursor-pointer': data?.vehicle?._id,
            }"
            @click="moveTo('vehicle', data?.vehicle?._id)"
          >
            <div>
              <div class="d-flex align-items-center">
                <div class="avtar" v-if="data?.vehicle?.vehiclePicture">
                  <img :src="data.vehicle.vehiclePicture" alt="vehiclePicture" />
                </div>
                <div v-if="data?.vehicle?._id">
                  <div class="bold-text title">
                    {{ $t('plate') }} #{{ data?.vehicle?.plateNumber }}
                  </div>
                  <!-- <div class="sub-title">
                    {{ $t("operational-id") }} :
                    <span class="bold-text">
                      #
                      {{ data?.vehicle?.operationalID }}
                    </span>
                  </div> -->
                  <div class="sub-title">
                    {{ $t('brand') }} :
                    <span class="bold-text">
                      {{ isLangRtl ? data?.vehicle?.make?.arabicName : data?.vehicle?.make?.name }}
                    </span>
                  </div>
                  <div class="sub-title">
                    {{ $t('model') }} :
                    <span class="bold-text">
                      {{
                        isLangRtl ? data?.vehicle?.model?.arabicName : data?.vehicle?.model?.name
                      }}
                    </span>
                  </div>
                  <div class="sub-title">
                    {{ $t('year-of-making') }} :
                    <span class="bold-text">
                      {{ data?.vehicle?.makeYear }}
                    </span>
                  </div>
                </div>
                <div v-else class="sub-title">
                  {{ $t('vehicle-not-assigned') }}
                </div>
              </div>
            </div>
            <div class="d-flex align-self-baseline gap-1">
              <b-button
                v-if="
                  !$store.getters['enums/is_not_permitted']('assignVehiclesToJourney') &&
                  data?.status !== 'Booking-Cancelled' &&
                  data?.status !== 'Booking-Cancelled-Note' &&
                  data?.status !== 'Trip-Arrived-To-Dropped-Off' &&
                  data?.status !== 'Trip-Passenger-Dropped-Off' &&
                  data?.status !== 'Trip-Completed' &&
                  data?.status !== 'Trip-Completed-Note' &&
                  (data?.status === 'Trip-Started'
                    ? !$store.getters['enums/is_not_permitted']('assignDriverForStartedTrip') &&
                      !$store.getters['enums/is_not_permitted']('assignVehicleForStartedTrip')
                    : true)
                "
                class="reassign-btn"
                @click.stop="changeVehicles"
              >
                {{ data?.vehicle?._id ? $t('reassign') : $t('assign') }}
              </b-button>
              <b-button
                v-if="
                  !$store.getters['enums/is_not_permitted']('assignVehiclesToJourney') &&
                  !data?.status?.startsWith('Trip-') &&
                  data?.vehicle?._id
                "
                class="remove-btn"
                variant="danger"
                @click.stop="showRemoveVehicleModal"
              >
                {{ $t('remove-vehicle') }}
              </b-button>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-2 mb-3">
        <div class="col-lg-6 col-md-6 col-xs-12">
          <div class="criteria-block d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center">
              <div>
                <div class="bold-text title">
                  {{ $t('driver-criteria') }}
                </div>
                <div class="sub-title" v-if="driverCriteria?.nationality">
                  {{ $t('nationality') }} :
                  <span class="bold-text">
                    {{ driverCriteria?.nationality }}
                  </span>
                </div>
                <div class="sub-title" v-if="driverCriteria?.spokenLanguages">
                  {{ $t('spoken-languages') }} :
                  <span class="bold-text">
                    {{ driverCriteria?.spokenLanguages }}
                  </span>
                </div>
                <div class="sub-title" v-if="driverCriteria?.religion">
                  {{ $t('religion') }} :
                  <span class="bold-text">
                    {{ driverCriteria?.religion }}
                  </span>
                </div>
                <div
                  v-if="
                    !driverCriteria?.nationality &&
                    !driverCriteria?.spokenLanguages &&
                    !driverCriteria.religion
                  "
                  class="sub-title"
                >
                  {{ $t('criteria-not-assign') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-xs-12">
          <div class="criteria-block d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center">
              <div>
                <div class="bold-text title">
                  {{ $t('vehicle-criteria') }}
                </div>
                <div class="sub-title" v-if="vehicleCriteria?.type">
                  {{ $t('vehicle-name') }} :
                  <span class="bold-text">
                    {{ vehicleCriteria?.type }}
                  </span>
                </div>
                <div class="sub-title" v-if="vehicleCriteria?.color">
                  {{ $t('color') }} :
                  <span class="bold-text">
                    {{ vehicleCriteria?.color }}
                  </span>
                </div>
                <div v-if="!vehicleCriteria?.type && !vehicleCriteria?.color" class="sub-title">
                  {{ $t('criteria-not-assign') }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-2 mb-3">
        <hr />
        <div v-if="contactPersonDetails" class="col-xs-12 mb-2">
          <div class="bold-text" style="margin-bottom: 18px">
            {{ $t('contact-person') }}
          </div>
          <div class="services-block-container">
            <div class="services-block">
              <div class="d-flex flex-column">
                <div>
                  {{ $t('name') }}:
                  <span class="bold-text">{{
                    isLangRtl ? contactPersonDetails?.arabicName : contactPersonDetails?.name
                  }}</span>
                </div>
              </div>
            </div>
            <div class="services-block">
              <div class="d-flex flex-column">
                <div>
                  {{ $t('mobile-number') }}:
                  <span class="bold-text">{{ contactPersonDetails?.mobileNumber }}</span>
                </div>
              </div>
            </div>
            <div class="services-block">
              <div class="d-flex flex-column">
                <div>
                  {{ $t('email-address') }}:
                  <span class="bold-text">{{ contactPersonDetails?.email }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="bold-text">{{ $t('contact-empty') }}</div>
        </div>
      </div>
      <div class="row mt-2">
        <hr />
        <div v-if="tripService?.comment" class="col-lg-6 col-md-6 col-xs-12 mb-2">
          <div class="services-block">
            <div class="d-flex flex-column">
              <div class="bold-text">{{ $t('comment') }} :</div>
              <div>{{ tripService?.comment }}</div>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="bold-text">{{ $t('comment-empty') }}</div>
        </div>
      </div>
      <div class="row mt-2" v-if="!$store.getters['enums/is_not_permitted']('transactionLogTab')">
        <hr />
        <div
          v-b-toggle="'collapse-logs-table'"
          class="product-container__header d-flex align-items-center justify-content-between flex-wrap"
        >
          <div class="d-flex align-items-center flex-wrap">
            <h2 class="title">
              {{ $t('logs') }}
            </h2>
          </div>
          <img
            :class="[{ 'rotate-180': logsShowing }, { 'rotate-180-reverse': !logsShowing }]"
            :src="require('@/assets/images/icons/arrow-down.svg')"
            alt="arrow"
          />
        </div>
        <b-collapse :id="'collapse-logs-table'" v-model="logsShowing">
          <div class="col-12 my-2" v-if="logsShowing">
            <TransactionTab :filterBy="{ id: data?._id, type: 'Trip' }" />
          </div>
        </b-collapse>
      </div>
      <div v-if="data">
        <ChangeVehiclesModel
          :trip="data"
          @selectedVehicle="setSelectedVehicle"
          :selectedDriverId="mainDriverDetails?.id"
        />
        <ChangeDriverModel
          :trip="data"
          @selectedDriver="setSelectedDriver"
          :selectedVehicleId="vehicleDetails?._id"
          :isMainDriver="isMainDriver"
          :isReassign="showReassignButton"
        />
        <EditTrip :data="data" @refreshData="refreshData" :garage="garage" />
        <CompleteWithNoteModal
          :id="data?._id"
          @updateTrip="updateTrip"
          :serviceAllowance="tripServiceAllowanceAmount"
        />
        <RemoveDriverModal :tripID="data?._id" @removeDriver="removeDriver" />
        <RemoveVehicleModal :tripID="data?._id" @removeVehicle="removeVehicle" />
        <CancelDeadHeadTripModal :tripID="data?._id" @cancelTrip="cancelTrip" />
        <TripFeedbackModal
          ref="feedbackModal"
          :tripId="data?._id"
          :rating="rating"
          :feedback="feedback"
        />
      </div>
      <ActualRoute :data="data" :type="type" />
      <MobileRouteMap :data="data" />
      <div class="position-relative pdf-content">
        <OrderDetailsPDF
          :pdfContent="pdfContent"
          :servicesDetailsItems="servicesDetailsItems"
          :customerDetailsItems="customerDetailsItems"
          :pdfContentDisplay="pdfContentDisplay"
          :customerDetailsFields="customerDetailsFields"
          :servicesDetailsFields="servicesDetailsFields"
          :debitClientOrCredit="debitClientOrCredit"
          :showPriceField="false"
        />
      </div>
      <!-- <div v-b-toggle="'collapse-rating-table'"
        class="product-container__header d-flex align-items-center justify-content-between flex-wrap">
        <div class="d-flex align-items-center flex-wrap">
          <h2 class="title">
            {{ $t("rating") }}
          </h2>
        </div>

        <img :class="[
          { 'rotate-180': ratingShowing },
          { 'rotate-180-reverse': !ratingShowing },
        ]" :src="require('@/assets/images/icons/arrow-down.svg')" alt="arrow" />
      </div> -->
      <!-- <b-collapse :id="'collapse-rating-table'" v-model="ratingShowing">
        <div class="col-12 my-2" v-if="ratingShowing">
          <TripRatingCard :tripId="data?._id" />
        </div>
      </b-collapse> -->
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import TripService from '@/services/trip.service'
import VehicleService from '@/services/vehicle.service'
import ChangeVehiclesModel from '@/components/Operations/Details/JourneyContainerComponents/Vehicle/ChangeVehicle/ChangeVehiclesModel.vue'
import ChangeDriverModel from '@/components/Operations/Details/JourneyContainerComponents/Driver/ChangeDriver/ChangeDriversModel.vue'
import CompleteWithNoteModal from './CompleteWithNoteModal.vue'
import ActualRoute from './actualRoute.vue'
import MobileRouteMap from './mobileRouteMap.vue'
import ChangeTripStatus from './changeTripStatus.vue'
import EditTrip from './edit/index.vue'
import RemoveDriverModal from './removeDriverModal.vue'
import RemoveVehicleModal from './removeVehicleModal.vue'
import TransactionTab from '@/components/TransactionLog/TransactionTab'
import OrderDetailsPDF from '@/components/Operations/Details/OrderDetailsPDF.vue'
import html2pdf from 'html2pdf.js'
import CancelDeadHeadTripModal from './cancelDeadHeadTripModal.vue'
import TripRatingCard from './TripRatingCard.vue'
import TripFeedbackModal from './feedbackTrip.vue'

// Trip statuses that will never change again — once the trip is in one of
// these, there's nothing left to poll for, so we stop refreshing.
const TERMINAL_TRIP_STATUSES = new Set([
  'Trip-Completed',
  'Trip-Completed-Note',
  'Booking-Cancelled',
  'Booking-Cancelled-Note',
])

// How often we re-fetch the trip while it's still in progress, purely to
// keep `data.status` fresh. This page has no socket subscription of its
// own for trip-status-change events (only MobileRouteMap subscribes to
// live-location pings) — without this poll, `data.status` (and therefore
// the `status` prop MobileRouteMap reads to decide which leg is active)
// would stay frozen at whatever it was when the page/modal first loaded,
// even long after the driver has actually moved from Pickup to DropOff.
const TRIP_STATUS_POLL_INTERVAL_MS = 10000

export default {
  props: ['id'],
  emits: ['update-flag', 'change-tab'],
  components: {
    ChangeVehiclesModel,
    ChangeDriverModel,
    ActualRoute,
    MobileRouteMap,
    CompleteWithNoteModal,
    ChangeTripStatus,
    EditTrip,
    RemoveDriverModal,
    RemoveVehicleModal,
    CancelDeadHeadTripModal,
    TransactionTab,
    OrderDetailsPDF,
    TripRatingCard,
    TripFeedbackModal,
  },
  data() {
    return {
      ratingShowing: false,
      action_loading: false,
      loading: false,
      error: null,
      data: null,
      currentId: this.id,
      vehicleDetails: {},
      mainDriverDetails: {},
      secondaryDriverDetails: {},
      tripService: {},
      isMainDriver: false,
      type: '',
      showMapSelection: false,
      contactPersonDetails: null,
      driverCriteria: {
        spokenLanguages: null,
        nationality: null,
        religion: null,
      },
      vehicleCriteria: {
        type: null,
        color: null,
      },
      logsShowing: false,
      pdfLoading: false,
      statusPollInterval: null,
      servicesDetailsFields: [
        {
          key: 'recievingTime',
          label: 'Recieving Time',
          class: 'align-middle pb-3',
        },
        {
          key: 'quantity',
          label: 'Quantity',
          class: 'align-middle pb-3',
          thStyle: { width: '30px' },
        },
        {
          key: 'busType',
          label: 'Bus Type',
          class: 'align-middle pb-3',
          thStyle: { width: '80px' },
        },
        {
          key: 'destination',
          label: 'Destination',
          class: 'align-middle pb-3',
          thStyle: { width: '160px' },
        },
        {
          key: 'recievingArea',
          label: 'Recieving Area',
          class: 'align-middle pb-3',
          thStyle: { width: '160px' },
        },
        {
          key: 'comment',
          label: 'comment',
          class: 'align-middle pb-3',
          thStyle: { width: '160px' },
        },
        {
          key: 'endDate',
          label: 'End Date',
          class: 'align-middle pb-3',
          thStyle: { width: '50px' },
        },
        {
          key: 'startDate',
          label: 'Start Date',
          class: 'align-middle pb-3',
          thStyle: { width: '50px' },
        },
        {
          key: 'description',
          label: 'Description',
          class: 'align-middle pb-3',
          thStyle: { width: '160px' },
        },
        {
          key: 's',
          label: 'S',
          class: 'align-middle pb-3',
        },
      ],
      servicesDetailsItems: [],
      customerDetailsFields: [
        {
          key: 'representativeContact',
          label: 'Representative Contact',
          class: 'align-middle pb-3',
        },
        {
          key: 'representative',
          label: 'Representative',
          class: 'align-middle pb-3',
        },
        {
          key: 'customerContact',
          label: 'Customer Contact',
          class: 'align-middle pb-3',
        },
        {
          key: 'address',
          label: 'Address',
          class: 'align-middle pb-3',
        },
        {
          key: 'customerName',
          label: 'Customer Name',
          class: 'align-middle pb-3',
        },
      ],
      customerDetailsItems: [],
      pdfContentDisplay: 'none',
      pdfContent: {},
      debitClientOrCredit: '',
      tripServiceAllowanceAmount: null,
      blanketOrder: null,
      zone: null,
      beneficiary: null,
      garage: null,
      driverIqamaEntryNumber: null,
      rating: 0,
      feedback: '',
    }
  },
  methods: {
    openFeedback() {
      this.$refs.feedbackModal.open()
    },
    moveTo(page, id) {
      if (!id) return
      const newWindow = window.open(`/${page}/${id}`, '_blank')
      newWindow?.focus()
    },
    showActualRouteModal(type) {
      this.type = type
      this.$nextTick(() => {
        this.$bvModal.show('actual-route-modal')
      })
    },
    showMobileRouteMapModal() {
      this.$nextTick(() => {
        this.$bvModal.show('mobile-route-map-modal')
      })
    },
    moveToEdit(trip) {
      this.$bvModal.show('modal-trip-' + trip)
    },

    showCancelTripModel() {
      this.$bvModal.show('cancel-deadhead-trip-model-' + this.data?._id)
    },
    changeDriver(isMainDriver) {
      this.isMainDriver = isMainDriver
      this.$bvModal.show('assign-driver-model-' + this.data?._id)
    },
    changeVehicles() {
      this.$bvModal.show('assign-vehicle-model-' + this.data?._id)
    },
    setSelectedVehicle(selectedVehicleId) {
      this.loading = true
      const data = {
        id: this.data._id,
        vehicle: selectedVehicleId?.toString() || '',
      }
      TripService.assignVehicle('assign-vehicle', data)
        .then(() => {
          let params = {
            select:
              'mainDriver.idNumber,make.name,make.arabicName,model.name,model.arabicName,category.name,category.arabicName,color,plateNumber,licenseNumber,vehiclePicture,makeYear,tgaNumber,chassisNumber,make.name,make.arabicName,operationalID,actualEndTime',
          }
          VehicleService.get(selectedVehicleId, params)
            .then((response) => {
              this.data['vehicle'] = response

              this.vehicleDetails = this.data?.vehicle
            })
            .catch(({ message }) => {
              this.error = message
            })

          this.getData(true)
        })
        .catch(({ message }) => {
          this.error = message
        })
        .finally(() => {
          this.loading = false
        })
    },
    setSelectedDriver(selectedDriver) {
      this.loading = true

      const { _id } = this.data
      const id = _id
      const driverId = selectedDriver.id

      let data = { id }
      let role, action

      if (this.isMainDriver) {
        if (this.showReassignButton) {
          data.mainDriver = driverId
          role = 'main'
          action = 'assign-driver-for-completed-trip'
        } else {
          data.driver = driverId
          role = 'main'
          action = 'assign-driver'
        }
      } else {
        if (this.showReassignButton) {
          data.secondaryDriver = driverId
          role = 'secondary'
          action = 'assign-driver-for-completed-trip'
        } else {
          data.driver = driverId
          role = 'secondary'
          action = 'assign-secondary-driver'
        }
      }

      this.assignDriver(data, selectedDriver, role, action)
    },
    getTripRating() {
      if (!this.data?._id) return

      TripService.getTripRating(this.data._id)
        .then((res) => {
          this.feedback = res?.items?.[0]?.beneficiaryComment || ''
          this.rating = res?.items?.[0]?.driverRating || 0
        })
        .catch((err) => {
          console.log(err)
        })
    },

    assignDriver(data, selectedDriver, type, endpoint) {
      TripService.put(data, endpoint)
        .then(() => {
          selectedDriver._id = selectedDriver.id
          if (type === 'main') {
            this.data.mainDriver = selectedDriver
            this.mainDriverDetails = this.data.mainDriver
          } else {
            this.data.secondaryDriver = selectedDriver
            this.secondaryDriverDetails = this.data.secondaryDriver
          }
          this.$store.dispatch('enums/SHOW_TOASTER_POP', {
            message: this.showReassignButton
              ? this.$t('reassign-driver-success')
              : this.$t('assign-driver-success'),
            variant: 'success',
            title: this.$t('success'),
            duration: 10000,
            noCloseButton: true,
            noAutoHide: false,
          })
          this.getData(true)
        })
        .catch(({ message }) => {
          this.error = message
        })
        .finally(() => {
          this.loading = false
        })
    },
    updateTrip(payload) {
      if (payload?.trip) {
        this.currentId = payload.trip._id // ← update local, not prop
        this.data = payload.trip
        this.getData()
      }
    },
    // THE FIX: keep polling the trip while it's still in progress, so
    // data.status (and every child that reads it — including
    // MobileRouteMap, which decides its "active leg" from this same
    // status) never stays stale for longer than TRIP_STATUS_POLL_INTERVAL_MS.
    startStatusPolling() {
      this.stopStatusPolling()

      if (!this.currentId || this.isTripInTerminalStatus) return

      this.statusPollInterval = setInterval(() => {
        // THE FIX: `silent = true` — a background poll must NEVER toggle
        // `loading`. Toggling it, even briefly, flips the page's
        // `v-if="loading" / v-else` and destroys + remounts the entire
        // subtree (including every modal in it), which was silently
        // closing whatever popup/modal the user had open every single
        // poll tick. A background refresh should update `data`
        // reactively in place, not tear down the page.
        this.getData(false, true)
      }, TRIP_STATUS_POLL_INTERVAL_MS)
    },
    stopStatusPolling() {
      if (this.statusPollInterval) {
        clearInterval(this.statusPollInterval)
        this.statusPollInterval = null
      }
    },
    getData(changeTab, silent = false) {
      if (this.currentId) {
        if (!silent) {
          if (changeTab) this.action_loading = true
          else this.loading = true
        }
        this.error = null
        let params = {
          select:
            'completedAt,mainDriver.idNumber,_id,reservation.client._id,reservation.client.arabicName,reservation.client.name,reservation.client.phoneNumber,reservation.category._id,reservation.category.arabicName,reservation.category.name,service._id,service.arabicName,service.name,service.category._id,service.category.arabicName,service.category.name,status,subStatus,reservation._id,service.startCity._id,service.startCity._id,service.startCity.arabicName,service.startCity.name,service.endCity.arabicName,service.endCity.name,service.numberOfDrivers,driver.garage.garageLocation.name,driver.garage.garageLocation.location,startLocation.location,startLocation.name,endLocation.location,endLocation.name,actualStartTime,deviationInStartTime,actualEndTime,deviationInEndTime,actualTripTime,totalDeviation,initialOdoMeter,finalOdoMeter,distance,deviationInDistance,mainDriver.vehiclePicture,mainDriver._id,mainDriver.arabicName,mainDriver.name,mainDriver.employeeID,secondaryDriver,secondaryDriver.vehiclePicture,secondaryDriver.arabicName,secondaryDriver.name,secondaryDriver.employeeID,secondaryDriver.idNumber,secondaryDriver._id,vehicle.vehiclePicture,vehicle._id,vehicle.plateNumber,vehicle.operationalID,vehicle.make.arabicName,vehicle.make.name,vehicle.model.arabicName,vehicle.model.name,vehicle.makeYear,branch._id,reservation.client.contactPerson,reservation.id,reservation.branch.arabicName,reservation.branch.name,reservation.status,reservation.type,reservation.numberOfVehicles,reservation.quantity,reservationService,service.allowanceAmount,driverCriteria,vehicleCriteria,isDeadhead,contract.contactPerson,contract.client.name,contract.client.arabicName,contract.client.contactPerson,contractService,contract.branch.name,contract.branch.arabicName,route.name,route.arabicName,reservation.blanketOrder,reservation.blanketOrder.orderCode,reservation.zone,reservation.zone.name,reservation.zone.arabicName,reservation.beneficiary,beneficiary.phoneNumber,beneficiary.arabicName,beneficiary.englishName,beneficiary.externalReferenceId,reservation.zone,garage,waterSource,garage._id, garage.name, garage.arabicName,scheduledEndTime,scheduledStartDate,scheduledEndDate,scheduledStartDate,scheduledStartTime,actualStartTime,actualEndTime,driver.mobileDevice.lastKnownLocation,driver.mobileDevice.lastTimeLocationUpdated',
        }

        TripService.get(this.currentId, params)
          .then((res) => {
            this.data = res

            this.getTripRating()
            this.garage = res?.garage
            this.tripServiceAllowanceAmount = res?.service?.allowanceAmount || 0
            this.data = res
            this.beneficiary = res?.beneficiary
            this.zone = this.data?.reservation?.zone || null
            this.vehicleDetails = this.data?.vehicle
            this.mainDriverDetails = this.data?.mainDriver
            this.secondaryDriverDetails = this.data?.secondaryDriver
            this.tripService = this.data?.reservation
              ? this.data.reservationService || {}
              : this.data?.contractService || {}
            this.blanketOrder = this.data?.reservation ? this.data?.reservation?.blanketOrder : null
            this.contactPersonDetails =
              this.data?.[
                this.data?.reservation ? 'reservation' : 'contract'
              ]?.client?.contactPerson?.find(
                (each) => each?._id === this?.tripService?.contactPerson
              ) || null
            // Vehicle Criteria
            this.vehicleCriteria.type = this.getVehicleTypeText(
              this.data?.isDeadhead && !this.data?.tripService
                ? this.data?.vehicleCriteria?.vehicleType
                : this.tripService?.vehicleCriteria?.vehicleType
            )
            this.vehicleCriteria.color =
              this.data?.isDeadhead && !this.data?.tripService
                ? this.data?.vehicleCriteria?.color
                : this.tripService?.vehicleCriteria?.color

            // Driver Criteria
            this.driverCriteria.nationality =
              this.getNationalitiesText(this.tripService?.driverCriteria?.nationality) ??
              (this.data?.isDeadhead && !this.data?.tripService
                ? this.getNationalitiesText(this.data?.driverCriteria?.nationality)
                : null)

            this.driverCriteria.spokenLanguages =
              this.getLanguagesText(this.tripService?.driverCriteria?.languages) ??
              (this.data?.isDeadhead && !this.data?.tripService
                ? this.getLanguagesText(this.data?.driverCriteria?.languages)
                : null)

            this.driverCriteria.religion = this.getReligionText(
              this.data?.isDeadhead &&
                !this.data?.tripService &&
                this.data?.driverCriteria?.religion
                ? this.data?.driverCriteria?.religion
                : this.tripService?.driverCriteria?.religion
            )
            if (changeTab) this.$emit('change-tab', res?.subStatus)

            // Keep the poller in sync with the freshly-fetched status:
            // stop once the trip has reached a terminal state, otherwise
            // make sure a poll loop is (still) running.
            if (this.isTripInTerminalStatus) {
              this.stopStatusPolling()
            } else {
              this.startStatusPolling()
            }
          })
          .catch(({ message }) => {
            if (!silent) this.error = message
          })
          .finally(() => {
            if (!silent) {
              if (changeTab) this.action_loading = false
              else this.loading = false
            }
          })
      }
    },
    viewed() {
      this.action_loading = true
      this.error = null
      TripService.patch(`${this.currentId}/viewed`)
        .then(() => {
          this.getData(true)
        })
        .catch(({ message }) => {
          this.error = message
          this.action_loading = false
        })
    },
    unview() {
      this.action_loading = true
      this.error = null

      TripService.patch(`${this.currentId}/unview`)
        .then(() => {
          this.getData(true)
        })
        .catch(({ message }) => {
          this.error = message
          this.action_loading = false
        })
    },
    refreshData(changeTab) {
      this.getData(changeTab)
      this.$emit('refetchData')
    },
    toggleShowMap() {
      this.showMapSelection = !this.showMapSelection
    },
    showRemoveDriverModal(isMainDriver) {
      this.isMainDriver = isMainDriver
      this.$bvModal.show('remove-driver-model-' + this.data?._id)
    },
    showRemoveVehicleModal() {
      this.$bvModal.show('remove-vehicle-model-' + this.data?._id)
    },
    removeDriver() {
      let tripServiceAction = this.isMainDriver ? 'unassignDriver' : 'unassignSecondaryDriver'

      this.loading = true

      const data = {
        id: this.data._id,
      }

      TripService[tripServiceAction](data)
        .then(() => {
          this.getData(true)
        })
        .catch(({ message }) => {
          this.error = message
        })
        .finally(() => {
          this.loading = false
        })
    },
    removeVehicle() {
      this.loading = true
      const data = {
        id: this.data._id,
      }
      TripService.put(data, 'unassign-vehicle')
        .then(() => {
          this.getData(true)
        })
        .catch(({ message }) => {
          this.error = message
        })
        .finally(() => {
          this.loading = false
        })
    },
    async generatePDF(createFile) {
      return new Promise((resolve, reject) => {
        this.pdfContentDisplay = 'none'
        if (!createFile) this.pdfLoading = true
        this.error = null

        let params = {
          select:
            '_id,type,branch.name,branch.arabicName,client.contactPerson.name,client.contactPerson.mobileNumber,client.vatNumber,servicesTotalPrice,finalPriceIncludingTax,client.phoneNumber,client.address,client.name,client.arabicName,client.created_on,services.service.price,services.service.pricingQuantity,services.service.taxType.percentage,services.service.toTime,services.service.serviceQuantity,services.service.vehicleCriteria,services.service.dropoffLocation,services.service.pickupLocation,services.service.toDate,services.service.fromDate,services.service.isProduct,discountPercentage,discountAmount,finalPrice,taxAmount,created_by,referenceNumber,contactPerson',
        }

        TripService.get(`trip-reservation/${this.id}`, params)
          .then((res) => {
            this.pdfContent = {
              id: res?._id,
              type: res?.type,
              branchEnglishName: res?.branch?.name,
              branchArabicName: res?.branch?.arabicName,
              taxNo: res?.client?.vatNumber,
              servicesTotalPrice: res?.servicesTotalPrice,
              finalPriceIncludingTax: res?.finalPriceIncludingTax?.toFixed(2),
              discountPercentage: res?.discountPercentage || '---',
              discountAmount: res?.discountAmount || '---',
              discountAfter: res?.finalPrice || '---',
              valueVAT: res?.taxAmount || '---',
              vatRateValue: res?.services.some((service) => {
                return service?.service?.taxType?.find((tax) => tax.percentage === 15)
              })
                ? '15'
                : '0',
              clientName: res?.created_by,
              confirmNo: res?.referenceNumber || '---',
            }
            this.customerDetailsItems = [
              {
                representativeContact:
                  res?.client?.contactPerson.find((el) => el._id === res.contactPerson)
                    ?.mobileNumber || '---',
                representative:
                  res?.client?.contactPerson.find((el) => el._id === res.contactPerson)?.name ||
                  '---',
                customerContact: res?.client?.phoneNumber,
                address: res?.client?.address,
                customerName: this.isLangRtl ? res?.client?.arabicName : res?.client?.name,
                startDate: moment(res?.client?.created_on)
                  .locale('en')
                  .utcOffset(0)
                  .format('DD-MM-YYYY'),
                endDate: '---',
              },
            ]
            this.debitClientOrCredit =
              res?.client?.paymentMethod === 'Debit' ? 'Cash / نقداً' : 'Postpaid / آجل'

            this.servicesDetailsItems = res?.services?.map((service, index) => {
              return {
                amount: service?.finalTotalPriceWithTax + 'SR',
                vat:
                  service?.service?.taxType?.reduce(
                    (accumulator, currentValue) => accumulator + currentValue?.percentage,
                    0
                  ) + '%',
                recievingTime: service?.fromTime,
                quantity: service?.serviceQuantity,
                busType:
                  (this.$store.getters['enums/brand_enums']?.find(
                    (brand) => brand.value === service?.vehicleCriteria?.make
                  )?.text || '---') +
                  ' - ' +
                  (this.$store.getters['enums/model_enums']?.find(
                    (model) => model.value === service?.vehicleCriteria?.model
                  )?.text || '---'),
                destination: this.shortText(service?.dropoffLocation?.name) || '---',
                recievingArea: this.shortText(service?.pickupLocation?.name) || '---',
                endDate: moment(service?.toDate).locale('en').format('YYYY-MM-DD'),
                startDate: moment(service?.fromDate).locale('en').format('YYYY-MM-DD'),
                description: this.shortText(service?.description) || '---',
                comment: this.shortText(service?.comment) || '---',
                s: index + 1,
              }
            })

            this.pdfContentDisplay = 'block'
            const element = document.getElementById('pdfContent')
            const pdfOptions = {
              margin: [0.2, 0.2, 0.2, 0.2],
              filename: 'clientStatement.pdf',
              image: { type: 'jpeg', quality: 0.98 },
              html2canvas: { scale: 2, useCORS: true },
              jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
            }

            let pdfUrl
            const reservationID = this.data?.reservation?._id
            html2pdf()
              .set(pdfOptions)
              .from(element)
              .toPdf()
              .get('pdf')
              .then(function (pdf) {
                pdf.setProperties({
                  title: `Reservation Details - ${reservationID}`,
                  subject: `Reservation Details - ${reservationID}`,
                  author: `Reservation Details - ${reservationID}`,
                  keywords: 'pdf, document',
                })
                pdfUrl = pdf.output(createFile ? 'blob' : 'bloburl')
                return pdfUrl
              })
              .then((pdfUrl) => {
                if (createFile) {
                  resolve(
                    new File([pdfUrl], `Sales Order-${reservationID}.pdf`, {
                      type: pdfUrl.type,
                    })
                  )
                } else {
                  this.pdfUrl = pdfUrl
                  this.pdfContentDisplay = 'none'

                  const url = pdfUrl
                  const link = document.createElement('a')
                  link.href = url
                  link.setAttribute('download', `Sales Order-${reservationID}`)
                  link.style.display = 'none'
                  document.body.appendChild(link)
                  link.click()
                  document.body.removeChild(link)
                }
              })
          })
          .catch((error) => {
            this.error = error?.message
            reject(error)
          })
          .finally(() => {
            if (!createFile) this.pdfLoading = false
          })
      })
    },
    cancelTrip(cancellationReason) {
      this.loading = true
      const data = {
        trips: [
          {
            id: this.data?._id,
            cancellationSource: 'system',
            cancellationReason: cancellationReason,
          },
        ],
      }
      TripService.put(data, 'v2/cancel')
        .then(() => {
          this.getData(true)
        })
        .catch(({ message }) => {
          this.error = message
        })
        .finally(() => {
          this.loading = false
        })
    },
    shortText(description) {
      if (!description) return
      const words = description?.split(' ')
      if (words?.length > 12) {
        return words?.slice(0, 12).join(' ') + '...'
      }
      return description
    },
    getNationalitiesText(nationalities) {
      return nationalities?.length && this.$store.getters['enums/nationality_enums'].length
        ? nationalities
            .map((each) => {
              const rec = this.$store.getters['enums/nationality_enums']?.find(
                (e) => e.code === each
              )
              return rec?.text
            })
            .join(', ')
        : null
    },
    getLanguagesText(languages) {
      return languages?.length && this.$store.getters['enums/language_enums'].length
        ? languages
            .map((each) => {
              const rec = this.$store.getters['enums/language_enums']?.find((e) => e.code === each)
              return rec?.text
            })
            .join(', ')
        : null
    },
    getVehicleTypeText(value) {
      const vehicleTypeList = this.$store.getters['enums/vehicle_type_enums'] || []
      const match = vehicleTypeList.find((e) => e.value === value)

      if (!match || match.text === 'select-an-option') {
        return null
      }

      return match.text
    },
    getReligionText(religion) {
      const religionList = this.$store.getters['enums/religion_enums'] || []
      const match = religionList.find((e) => e.value === religion)

      if (!match || match.text === 'select-an-option') {
        return null
      }

      return match.text
    },
  },
  computed: {
    completedAtFormatted() {
      return this.data?.completedAt
        ? moment(this.data.completedAt).locale('en').format('DD-MM-YYYY HH:mm')
        : '---'
    },
    checkTime() {
      let a = moment(),
        b = moment()
      if (this.data?.scheduledStartDate && this.data?.scheduledStartTime) {
        const from_time_parts = this.data.scheduledStartTime.split(':')

        a = moment(this.data.scheduledStartDate)
          .set('hour', from_time_parts[0])
          .set('minute', from_time_parts[1])
          .set('seconds', 0)
        const minutes = a.diff(b, 'minutes')
        // more than 24 hours
        return minutes > 1440 ? true : false
      } else return true
    },
    getStartDate() {
      return this.data?.scheduledStartDate
        ? moment(this.data.scheduledStartDate).locale('en').utcOffset(0).format('DD-MM-YYYY')
        : ''
    },
    getStartTime() {
      return this.data?.scheduledStartTime
        ? moment.utc(this.data.scheduledStartTime).locale('en').local().format('HH:mm')
        : ''
    },
    getEndDate() {
      return this.data?.scheduledEndDate
        ? moment(this.data.scheduledEndDate).locale('en').utcOffset(0).format('DD-MM-YYYY')
        : ''
    },
    getEndTime() {
      return this.data?.scheduledEndTime
        ? moment.utc(this.data.scheduledEndTime).locale('en').local().format('HH:mm')
        : ''
    },
    getActualStartTime() {
      return this.data?.actualStartTime
        ? moment(this.data.actualStartTime).locale('en').local().format('HH:mm')
        : ''
    },
    getActualEndTime() {
      return this.data?.completedAt
        ? moment.utc(this.data.completedAt).locale('en').local().format('HH:mm')
        : ''
    },
    getDeviationInStartTime() {
      return this.data?.deviationInStartTime
        ? moment(this.data.deviationInStartTime).locale('en').utcOffset(0).format('HH:mm')
        : ''
    },
    getDeviationInEndTime() {
      return this.data?.deviationInEndTime
        ? moment(this.data.deviationInEndTime).locale('en').utcOffset(0).format('HH:mm')
        : ''
    },
    showCompleteWithNote() {
      return (
        this.data?._id &&
        !this.$store.getters['enums/is_not_permitted']('changeJourneyStatus') &&
        (this.data.status === 'Trip-Started' ||
          this.data.status === 'Trip-Arrived-At-Pickup-Location' ||
          this.data.status === 'Trip-Passenger-Picked-Up' ||
          this.data.status === 'Trip-Passenger-Dropped-Off' ||
          this.data.status === 'Trip-Arrived-To-Dropped-Off')
      )
    },
    allowEdit() {
      if (this.data?.isDeadhead) return false

      return (
        !this.$store.getters['enums/is_not_permitted']('editTripByOperator') &&
        (!this.$store.getters['enums/is_not_permitted']('editTripLocationByOperator') ||
          !this.$store.getters['enums/is_not_permitted']('editTripDateAndTimeByOperator')) &&
        this.data?.reservation?.status !== 'Booking-Cancelled' &&
        this.data?.reservation?.status !== 'Booking-Cancelled-Note' &&
        this.data?.status !== 'Booking-Cancelled' &&
        this.data?.status !== 'Booking-Cancelled-Note' &&
        this.data?.status !== 'Trip-Arrived-To-Dropped-Off' &&
        this.data?.status !== 'Trip-Passenger-Dropped-Off' &&
        this.data?.status !== 'Trip-Arrived-At-Pickup-Location' &&
        this.data?.status !== 'Trip-Completed' &&
        this.data?.status !== 'Trip-Completed-Note' &&
        this.data?.status !== 'Trip-Started'
      )
    },
    hasPermissionPrintSalesOrder() {
      return !this.$store.getters['enums/is_not_permitted']('printSalesOrderForOperation')
    },
    showCancelButton() {
      const allowedStatuses = new Set([
        'Booking-Confirmed',
        'Booking-Re-Assigned',
        'Booking-Un-Assigned',
        'Booking-Pending',
      ])

      const isAllowedToChangeStatus =
        !this.$store.getters['enums/is_not_permitted']('editTripByOperator')
      const tripStatus = this.data?.status

      if (!isAllowedToChangeStatus) {
        return false
      }

      return allowedStatuses.has(tripStatus)
    },
    isReservationTrip() {
      return !!this.data?.reservation
    },
    clientName() {
      const reservationClient = this.data?.reservation?.client
      const contractClient = this.data?.contract?.client

      if (this.isReservationTrip) {
        return this.isLangRtl ? reservationClient?.arabicName : reservationClient?.name
      } else {
        return this.isLangRtl ? contractClient?.arabicName : contractClient?.name
      }
    },
    showReassignButton() {
      return (
        !this.$store.getters['enums/is_not_permitted']('reAssignDriverForCompletedTrip') &&
        (this.data?.status === 'Trip-Completed' || this.data?.status === 'Trip-Completed-Note')
      )
    },
    // THE FIX: single source of truth for "has this trip reached a state
    // that will never change again" — used to start/stop the status
    // poller. Kept as its own computed so both getData() and
    // startStatusPolling() agree on the same definition.
    isTripInTerminalStatus() {
      return TERMINAL_TRIP_STATUSES.has(this.data?.status)
    },
  },
  watch: {
    id(newVal) {
      this.currentId = newVal // ← keep in sync when prop changes
      this.getData()
    },
  },
  created() {
    this.$store.dispatch('enums/GET_VEHICLE_TYPE_ENUMS')
    this.$store.dispatch('enums/GET_COLOR_ENUMS')
    this.$store.dispatch('enums/GET_RELIGION_ENUMS')
    this.$store.dispatch('enums/GET_LANGUAGE_ENUMS')
    this.$store.dispatch('enums/GET_NATIONALITY_ENUMS')
    this.$store.dispatch('enums/GET_DRIVERS_AVAILABLE_NATIONALITY_ENUMS')
    this.$store.dispatch('enums/GET_BRAND_ENUMS')
    this.$store.dispatch('enums/GET_MODEL_ENUMS')
    this.$store.dispatch('enums/GET_WATER_SOURCE_ENUMS')
  },
  mounted() {
    this.getData()
  },
  beforeDestroy() {
    // THE FIX: never leave the poll timer running after this page/tab is
    // torn down — otherwise it keeps calling getData() on a destroyed
    // component instance indefinitely.
    this.stopStatusPolling()
  },
  i18n: {
    messages: {
      en: require('@/services/i18n/locales/en/manageTrips.json'),
      ar: require('@/services/i18n/locales/ar/manageTrips.json'),
    },
  },
}
</script>

<style lang="scss" scoped>
.header-block {
  border-radius: 0.5rem;
  border: 1px solid var(--color-64);
  background: var(--color-01);
  padding: 0.5rem 0.8125rem;
  box-shadow: 0px 2px 8px 2px var(--color-37);
  font-size: 15px;
}

.icon-container {
  border-radius: 0.375rem;
  background: var(--color-142);
  padding: 0.15rem;
  width: 1.5rem;
  height: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.trip-place-container {
  border-radius: 0.5rem;
  border: 1px solid var(--color-64);
  padding: 1.25rem 1.5rem;

  .route {
    height: 0.1875rem;
    background: var(--color-99);
  }

  .point {
    top: -6px;
    border-radius: 50%;
    width: 0.9375rem;
    height: 0.9375rem;
    background-color: var(--color-80);
    border: 4px solid var(--color-89);
  }

  .point.start {
    position: absolute;
    left: 0px;
  }

  .point.end {
    position: absolute;
    right: 0px;
  }

  .point.pick-up {
    position: absolute;
  }

  .point.drop-off {
    position: absolute;
  }

  .place {
    top: 12px;
  }

  .place.start {
    flex: 0.5;
    text-align: left;
  }

  .place.end {
    flex: 0.5;
    text-align: right;
  }

  .place.pick-up {
    flex: 0.5;
    text-align: center;
  }

  .place.drop-off {
    flex: 0.5;
    text-align: center;
  }
}

.bold-text {
  font-weight: 700;
}

.assign-block {
  border-radius: 0.5rem;
  background: var(--color-84);
  padding: 0.5rem 0.75rem;

  .avtar {
    background: var(--color-01);
    border-radius: 50%;
    margin-inline-end: 0.5rem;
    width: 3.3125rem;
    height: 3.3125rem;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  .title {
    font-size: 0.875rem;
  }

  .sub-title {
    font-size: 0.75rem;
  }

  .reassign-btn {
    border-radius: 0.375rem;
    background: var(--color-85);
    padding: 0.5rem 0.625rem;
    color: var(--color-101);
    font-size: 0.75rem;
    font-weight: 700;
  }

  .remove-btn {
    padding: 0.5rem 0.625rem;
    font-size: 0.75rem;
    font-weight: 700;
    color: var(--color-01);
    border-radius: 0.375rem;
  }
}

.info-block {
  padding: 0.625rem;
  border-radius: 0.5rem;

  .icon {
    display: flex;
    padding: 0.4375rem;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
  }
}

.services-block-container {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;

  .services-block {
    width: 50%;

    &:nth-child(odd) {
      width: calc(50% - 24px);
    }
  }
}

.services-block {
  border-radius: 0.5rem;
  background: var(--color-01);
  padding: 0.5rem 0.75rem;
  box-shadow: 0px 12px 16px var(--color-38);
  border: 1px solid var(--color-14);
}

.show-map-options {
  position: absolute;
  top: 45px;
  width: 95%;
  z-index: 9999;
  background: var(--color-01);
  border: 1px solid var(--color-14);
  box-shadow: 0px 2px 3px var(--color-38);
  border-radius: 4px;

  .option {
    cursor: pointer;
    padding: 0.5rem;
    font-size: 12px;
    line-height: 24px;
    color: var(--color-02);
  }

  .option:hover {
    background-color: var(--color-23);
    color: var(--color-01);
  }
}

.criteria-block {
  border-radius: 0.5rem;
  border: 1px solid var(--color-84);
  padding: 0.5rem 0.75rem;

  .title {
    font-size: 0.875rem;
  }

  .sub-title {
    font-size: 0.75rem;
  }

  .reassign-btn {
    border-radius: 0.375rem;
    background: var(--color-85);
    padding: 0.5rem 0.625rem;
    color: var(--color-101);
    font-size: 0.75rem;
    font-weight: 700;
  }
}

.pdf-content {
  visibility: hidden;
}

.btn-rating {
  border: none;
  background: transparent;
}
</style>